import {Inject, Injectable} from '@angular/core';
import {Observable, Observer} from 'rxjs';
import Pusher from 'pusher-js';
import axios from 'axios';

@Injectable({
  providedIn: 'root'
})
export class NgOrelCardIpgService {

  pusher: any;
  channel: any;
  showPage$: Observable<boolean>;
  private ifShowPage: Observer<boolean>;
  getSession$: Observable<string>;
  private setSession: Observer<string>;
  selectedStage$: Observable<string>;
  private setStage: Observer<string>;
  currentStage: string;
  configuration = {
    local: {
      apiUrl: 'https://orel.mpg/api/extGateway',
    },
    dev: {
      apiUrl: 'https://dev.paymediasolutions.com/v1/mpg/api/extGateway',
    },
    prod: {
      apiUrl: 'https://prod.orelpay.lk/v1/mpg/api/extGateway',
    }
  };

  constructor(@Inject('config') private config) {
    axios.defaults.baseURL = this.configuration[config.stage].apiUrl;
    axios.defaults.headers.post['Content-Type'] = 'application/json';
    axios.defaults.headers.common['x-plugin-source'] = 'ng-orel-card-ipg';
    axios.defaults.headers.common['x-plugin-version'] = '1.0.10';

    this.showPage$ = new Observable<boolean>(x => this.ifShowPage = x);
    this.getSession$ = new Observable<string>(st => this.setSession = st);
    this.selectedStage$ = new Observable<string>(stg => this.setStage = stg);
    this.currentStage = config.stage;
  }

  AddCard(token: string, reference: string): Promise<any> {
    this.writeLog(this.currentStage, 'AddCard: ' + token + '-' + reference);
    this.setStage.next(this.config.stage);

    return new Promise((resolve, reject) => {
      axios.defaults.headers.common.Authorization = 'Bearer ' + token;
      axios.post('/getGatewaySession', {reference})
        .then(response => {
          this.writeLog(this.currentStage, 'gateway-response: ' + response.data);
          if (response.data.status === 200) {
            console.log('getGatewaySession', 'success');

            const sessionData = response.data.data;
            const sessionId = sessionData.session;

            this.setSession.next(sessionId);
            this.activePuser(sessionData._apk, sessionId);

            this.ifShowPage.next(true);
            this.channel.bind(sessionId, (paymentResponse) => {
              this.pusher.unsubscribe(sessionId + '-channel');
              this.writeLog(this.currentStage, 'gateway-3ds-response: ' + paymentResponse);
              resolve(paymentResponse);
            });

          } else {
            reject({
              status: 400,
              data: {
                error: 'SERVER_ERROR',
                message: 'Payment session create failed.'
              }
            });
          }
        })
        .catch(error => {
          this.writeLog(this.currentStage, 'gateway-error-response: ' + error);
          let msg = '';
          if (error.response.status === 401) {
            msg = 'Unauthorized, Invalid token.';
          } else {
            msg = 'Something went wrong.';
          }

          reject({
            status: 400,
            data: {
              error: 'INIT_ERROR',
              message: msg
            }
          });
        });
    });
  }

  private activePuser = (apiKey: string, channel: string) => {
    this.pusher = new Pusher(apiKey, {
      cluster: 'ap2',
      forceTLS: false
    });
    this.pusher.logToConsole = this.currentStage !== 'prod';
    this.pusher.log = (msg) => {
      console.log(msg);
    };
    this.channel = this.pusher.subscribe(channel + '-channel');
  }

  private writeLog = (stage: string, msg: string) => {
    if (stage !== 'prod') {
      console.log('ng-orel-card-ipg: INFO: ' + msg);
    }
  }

}
